import { useMutation } from '@tanstack/react-query'

import { useMe } from '@shared/providers/src/MeProvider'
import { queryClient } from '@shared/providers/src/QueryClientProvider'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export function useCreateAppointment() {
  const { id } = useMe()
  return useMutation({
    mutationFn: (data) => API.patients.id(id).appointments.create(data),
  })
}

export function useUpdateAppointment(appointmentId, options = {}) {
  const { id } = useMe()
  return useMutation({
    mutationFn: (data) => API.patients.id(id).appointments.id(appointmentId).update(data),
    ...options,
  })
}

export function invalidateCache(id, { invalidateMe = false } = {}) {
  if (invalidateMe) queryClient.invalidateQueries({ queryKey: QK.me(id).details })
  queryClient.invalidateQueries({ queryKey: QK.patients.id(id).todos.lists })
  queryClient.invalidateQueries({ queryKey: QK.patients.id(id).appointments.lists })
}
